// /frontend/src/features/cart/cartSlice.js
import { createSlice } from '@reduxjs/toolkit';

// Get cart from localStorage
const cartItems = localStorage.getItem('cartItems')
  ? JSON.parse(localStorage.getItem('cartItems'))
  : [];

const shippingAddress = localStorage.getItem('shippingAddress')
  ? JSON.parse(localStorage.getItem('shippingAddress'))
  : {};

const initialState = {
  cartItems,
  shippingAddress,
  paymentMethod: 'Credit Card',
  itemsPrice: 0,
  shippingPrice: 0,
  taxPrice: 0,
  totalPrice: 0,
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;
      const existItem = state.cartItems.find((x) => x._id === item._id);

      if (existItem) {
        state.cartItems = state.cartItems.map((x) =>
          x._id === existItem._id ? item : x
        );
      } else {
        state.cartItems = [...state.cartItems, item];
      }

      // Save to localStorage
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter((x) => x._id !== action.payload);
      
      // Save to localStorage
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    clearCart: (state) => {
      state.cartItems = [];
      
      // Save to localStorage
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
    },
    saveShippingAddress: (state, action) => {
      state.shippingAddress = action.payload;
      
      // Save to localStorage
      localStorage.setItem('shippingAddress', JSON.stringify(action.payload));
    },
    savePaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    calculatePrices: (state) => {
      // Calculate items price
      state.itemsPrice = state.cartItems.reduce(
        (acc, item) => acc + item.price * item.qty,
        0
      );
      
      // Calculate shipping price (if order is over $100, shipping is free)
      state.shippingPrice = state.itemsPrice > 100 ? 0 : 10;
      
      // Calculate tax price (10% tax)
      state.taxPrice = Number((0.1 * state.itemsPrice).toFixed(2));
      
      // Calculate total price
      state.totalPrice = (
        Number(state.itemsPrice) +
        Number(state.shippingPrice) +
        Number(state.taxPrice)
      ).toFixed(2);
    },
    // For design collaboration options
    updateDesignOptions: (state, action) => {
      const { productId, options } = action.payload;
      const item = state.cartItems.find((x) => x._id === productId);
      
      if (item) {
        item.designOptions = options;
        state.cartItems = state.cartItems.map((x) =>
          x._id === productId ? item : x
        );
        
        // Save to localStorage
        localStorage.setItem('cartItems', JSON.stringify(state.cartItems));
      }
    }
  },
});

export const {
  addToCart,
  removeFromCart,
  clearCart,
  saveShippingAddress,
  savePaymentMethod,
  calculatePrices,
  updateDesignOptions,
} = cartSlice.actions;

export default cartSlice.reducer;